import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";

import {
  getAnalyticsConsent,
  setAnalyticsConsent,
  subscribeAnalyticsConsent,
} from "./analytics.js";

export function AnalyticsConsentControl({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const consent = useSyncExternalStore(
    subscribeAnalyticsConsent,
    getAnalyticsConsent,
    getAnalyticsConsent,
  );

  if (compact) {
    return (
      <div
        className="analytics-consent analytics-consent--compact"
        aria-label={t("analytics.title")}
      >
        <strong>{t("analytics.title")}</strong>
        <button
          type="button"
          data-testid="analytics-toggle"
          aria-pressed={consent === "granted"}
          onClick={() => setAnalyticsConsent(consent === "granted" ? "denied" : "granted")}
        >
          {t(consent === "granted" ? "analytics.allowShort" : "analytics.denyShort")}
        </button>
        <span className="sr-only" role="status" aria-live="polite">
          {consent === "granted"
            ? t("analytics.statusAllowed")
            : consent === "denied"
              ? t("analytics.statusDenied")
              : t("analytics.statusUnset")}
        </span>
      </div>
    );
  }

  return (
    <div className="analytics-consent" aria-labelledby="analytics-consent-title">
      <strong id="analytics-consent-title">{t("analytics.title")}</strong>
      <p>{t("analytics.description")}</p>
      <div className="analytics-consent__actions">
        <button
          type="button"
          data-testid="analytics-allow"
          aria-pressed={consent === "granted"}
          onClick={() => setAnalyticsConsent("granted")}
        >
          {t("analytics.allow")}
        </button>
        <button
          type="button"
          data-testid="analytics-deny"
          aria-pressed={consent === "denied"}
          onClick={() => setAnalyticsConsent("denied")}
        >
          {t("analytics.deny")}
        </button>
      </div>
      <span role="status" aria-live="polite">
        {consent === "granted"
          ? t("analytics.statusAllowed")
          : consent === "denied"
            ? t("analytics.statusDenied")
            : t("analytics.statusUnset")}
      </span>
    </div>
  );
}
